//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import EntrySuggestion from 'src/store/models/EntrySuggestion';
import SuggestionDetail from 'src/components/Entries/Entity';
import { dialog } from 'src/boot/mixins.js';
import moment from 'moment';
export default {
  mixins: [dialog],
  props: ['date'],
  components: {
    SuggestionDetail: SuggestionDetail
  },
  computed: {
    suggestions: function suggestions() {
      return EntrySuggestion.query().where('user_id', this.me.user_id).where('entry_date', moment(this.date).format('YYYY-MM-DD')).with(['project', 'user', 'user.avatar', 'phase']).get();
    }
  },
  methods: {
    deleteAllSuggestions: function deleteAllSuggestions() {
      var _this = this;

      EntrySuggestion.api().post('/entry-suggestions/delete-all', {
        date: moment(this.date).format('YYYY-MM-DD')
      }).then(function (data) {
        if (data.response.status === 200) {
          EntrySuggestion.delete(function (suggestion) {
            return suggestion.user_id === _this.me.user_id && suggestion.entry_date === moment(_this.date).format('YYYY-MM-DD');
          });

          _this.$q.notify({
            type: 'positive',
            message: _this.$t('components.suggestionsDialog.suggestions_ignored')
          });
        } else {
          _this.$q.notify({
            type: 'negative',
            message: _this.$t('components.suggestionsDialog.problem_ignoring_suggestions')
          });
        }

        _this.hide();
      }).catch(function () {});
    },
    onChange: function onChange() {
      if (this.suggestions.length <= 0) {
        this.hide();
      }
    }
  }
};